import React, { Component } from 'react';
import { Grid, Header, Image, Segment } from 'semantic-ui-react';

const libMut=require('../../img/icons/libmut.png');
const rTspec=require('../../img/icons/rt_logo_H_rgb.png')
const crc=require('../../img/icons/CRC_logo.png');
const cna=require('../../img/icons/CNA_logo.png');
const thehartford=require('../../img/icons/thehartford_logo.png');

class Partners extends Component {
  render() {
    return (
      <Segment style={{ padding: '8em 0em' }} vertical>
        <Grid container stackable>
          <Grid.Row>
            <Grid.Column width={16}>
               <Header as='h3' style={{ fontSize: '2.5em', fontFamiy: 'Raleway', fontFamily: 'serif'}}> Our insurance partners. </Header>
               <Header as='h2'>We work directly with some of the largest insurance carriers with A+ rated financial backing.</Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={5}>
            <Grid.Column verticalAlign='middle'>
              <Image href='https://www.cna.com/web/guest/cna/about/' size='medium' src={cna} title='CNA'/>
            </Grid.Column>

            <Grid.Column verticalAlign='middle'>
              <Image href='https://www.libertymutual.com/about-lm/our-company/our-company' size='medium' src={libMut} title='Liberty Mutual' />
            </Grid.Column>

            <Grid.Column verticalAlign='middle'>
              <Image href='http://www.crcgroupins.com/contact.html' size='medium' src={crc} title='CRC' />
            </Grid.Column>

            <Grid.Column verticalAlign='middle'>
              <Image href='https://rtspecialty.com/why-rt/' size='medium' src={rTspec} title='RT Specialty' />
            </Grid.Column>

            <Grid.Column verticalAlign='middle'>
              <Image href='https://www.thehartford.com/about-us'size='medium' src={thehartford} title='The Hartford'/>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
};

export default Partners;



// WEBPACK FOOTER //
// ./src/js/Home/Partners.js